import React from "react";
import './style.css';
import { useLanguage } from '../../LanguageContext';

const ErrorLoading = () => {
  const { selectedLanguage } = useLanguage();
  return (
    <div className="error-loading">
      <p>
        {selectedLanguage === 'it'
          ? 'Servizio temporaneamente non disponibile, riprova più tardi.'
          : 'Service temporarily unavailable, please try again later.'}
      </p>
    </div>
  );
};

export default ErrorLoading;
